<template>
    <div class="qm-open-app" @click="openQimaoApp" @click.stop="openQimaoApp">
        <slot>
            <p class="default-btn">下载并打开七猫免费小说app</p>
        </slot>
        <template v-if="storeCommon.systemInfo.isWeixin && showWxNativeComp">
            <wx-open-launch-app id="launch-btn" appid="wx4ab005521f9f1c04" :extinfo="wxConfig.extinfo">
                <script v-is="'script'" type="text/wxtag-template">
                    <style>.btn{position:absolute;left:0;top:0;width:100%;height:100%;}</style>
                    <div class="btn"></div>
                </script>
            </wx-open-launch-app>
        </template>
        <div class="guide" v-if="openFromOthers" @click.stop="openFromOthers = false">
            <img class="guide-img" src="@common/assets/images/web-open-guide.png" alt="" />
        </div>
    </div>
</template>

<script lang="ts" setup>
import { apiInitWxConfig } from '@common/http/api';
import { ref, PropType, onMounted, computed } from 'vue';
import { useStoreCommon } from '@common/store/common';

interface IPropsParams {
    androidDeeplink?: string;
    iosDeeplink?: string;
    androidDownlink?: string;
    iosDownlink?: string;
    title?: string;
    link?: string;
    desc?: string;
    imageUrl?: string;
}
const props = defineProps({
    params: {
        type: Object as PropType<IPropsParams>,
        default: () => ({}),
    },
});

const storeCommon = useStoreCommon();
let timeFn = null;

const emits = defineEmits(['buttonShow', 'buttonClick']);
const openFromOthers = ref(false); // 是否从其他app打开
const isOpening = false; // 判断是否处于打开app中
const wxConfig = ref<Record<string, any>>({});
const showWxNativeComp = ref(false);
const setWxConfig = async() => {
    if (!storeCommon.systemInfo.isWeixin) {
        return;
    }
    const wxSdk = await import('weixin-js-sdk') as any;
    const res = await apiInitWxConfig(location.href.split('#')[0]);
    const { appId, timestamp, nonceStr, signature, } = res.data;
    wxConfig.value = { appId, extinfo: pathSchema.value, };
    storeCommon.setWxConfig({ data: res.data, extinfo: pathSchema.value, });
    console.log('wxConfig', wxConfig.value);
    await wxSdk.config({ debug: false, appId, timestamp, nonceStr, signature, jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'], openTagList: ['wx-open-launch-app'], });
    showWxNativeComp.value = true;
    wxSdk.error((res: any) => {
        console.log('wx error--------------------------------', res);
        showWxNativeComp.value = false;
        emits('buttonShow');
        console.log('showWxNativeComp-error', showWxNativeComp.value);
    });
    wxSdk.ready(() => {
        const { title = '', link = '', desc = '', imageUrl = '', } = props.params;
        if (!title && !link && !desc && !imageUrl) return;
        wxSdk?.updateAppMessageShareData({
            title,
            link,
            desc,
            imgUrl: imageUrl || '',
            success: function() {
                console.log('updateAppMessageShareData success');
            },
        });
        wxSdk?.updateTimelineShareData({
            title,
            link,
            desc,
            imgUrl: imageUrl || '',
            success: function() {
                console.log('updateTimelineShareData success');
            },
        });
    });

    listenBtn();
};

const listenBtn = () => {
    const btn = document.getElementById('launch-btn');
    if (!btn && showWxNativeComp.value) {
        return setTimeout(() => {
            listenBtn();
        }, 100);
    }
    // config配置挂载完毕
    btn?.addEventListener('ready', () => {
        console.log('ready');
        emits('buttonShow', 'weChat');
    });
    // 点击打开app微信操作
    btn?.addEventListener('launch', () => {
        console.log('success');
        emits('buttonClick', 'weChat');
    });
    // 在复制链接里打开会出现launch:fail的情况，走原始逻辑，打开引导 - 自测可先收藏
    btn?.addEventListener('error', (err: any) => {
        console.log('error', err);
        openFromOthers.value = true;
    });
};

const pathSchema = computed(() => {
    const androidUrl = props.params.androidDeeplink || 'freereader://';
    const iosUrl = props.params.iosDeeplink || 'freereader://';
    return storeCommon.systemInfo.isIos ? iosUrl : androidUrl;
});

const openQimaoApp = () => {
    const { isWeixin, isQQ, isWeibo, isPcWeixin, } = storeCommon.systemInfo;
    if (isWeixin && showWxNativeComp.value) {
        return;
    }
    if (isWeixin || isQQ || isWeibo) {
        openFromOthers.value = true;
        return;
    }
    const {
        androidDeeplink = 'freereader://',
        iosDeeplink = 'freereader://',
        androidDownlink = 'https://download.wtzw.com/v2.0/qm-mshare.apk',
        iosDownlink = 'https://itunes.apple.com/cn/app/id1387717110',
        harmonyDownlink = 'https://appgallery.huawei.com/app/detail?id=com.qimao.novel',
        isForceDownload = false,
    } = props.params;

    // 安卓唤端稍有特殊
    let openUrl = storeCommon.systemInfo.isIos ? iosDeeplink : `freereader://xiaoshuo.km.com/adload?skipad=1&param=${encodeURIComponent(androidDeeplink)}`;
    const _downUrl = storeCommon.systemInfo.isIos ? iosDownlink : storeCommon.systemInfo.isHarmony ? harmonyDownlink : androidDownlink;

    // iOS 避免直接 universal link 打开
    openUrl = openUrl.replace(/app-share.wtzw.com/, 'xiaoshuo.wtzw.com');
    console.log('openUrl', openUrl);
    window.open(openUrl, '_self');

    timeFn = setTimeout(() => {
        console.log('setTimeout', timeFn);
        window.open(_downUrl, '_self');
    }, 3000);
};
defineExpose({
    openQimaoApp,
});
onMounted(async() => {
    console.log('onMounted-wxConfig', storeCommon.systemInfo.isWeixin);
    // 分享使用逻辑
    // 1、分享出去链接位app-share.wtzw.com域名，原因手机系统下载七猫app会记录xiaoshuo.wtzw，会超越控制，影响使用
    // 2、在外部浏览器打开中，页面初始化不能调用scheme，不然会越过打开app，无法进入目标页

    setWxConfig();
    // 监听页面变化
    document.addEventListener(
        'visibilitychange',
        () => {
            console.log('visibilitychange', timeFn);
            if (timeFn) {
                clearTimeout(timeFn);
            }
        },
        false
    );
});
</script>
<style lang="scss">
#launch-btn {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 9999;
}
</style>
<style lang="scss" scoped>
.qm-open-app {
    width: 720px;
    position: fixed;
    left:  calc((100% - 720px) / 2);
    bottom: 0;
    z-index: 999;
    .default-btn {
        margin: 40px;
        padding: 22px 0;
        background: linear-gradient(90deg, #FFE040 0%, #FCC800 100%);
        border-radius: 44px;
        font-size: 32px;
        text-align: center;
        font-weight: bold;
        color: #222;
        line-height: 44px;
    }

}
    .guide {
        background-color: rgba(0, 0, 0, 0.7);
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 2000;

        &-img {
            width: 100%;
        }
    }
</style>
